import OptimizerEditDto from './OptimizerEditDto';

export class DogLegOptimizerEditDto extends OptimizerEditDto {
    constructor() {
        super();
        /** @type {number} */
        this.initialTrustRadius = null;
        /** @type {number} */
        this.maxTrustRadius = null;
        /** @type {number} */
        this.tol = null;
        /** @type {number} */
        this.eta = null;
        /** @type {number} */
        this.gtol = null;
    }

    /**
     * @typedef {Object} DogLegOptimizerEditDto
     * @property {number} initialTrustRadius 
     * @property {number} maxTrustRadius 
     * @property {number} tol 
     * @property {number} eta 
     * @property {number} gtol 
     * 
     * @typedef {import('./OptimizerEditDto').OptimizerEditDtoProps & _DogLegOptimizerEditDtoProps} DogLegOptimizerEditDtoProps
     */
    /**
     * 
     * @param {DogLegOptimizerEditDtoProps} props
     * @returns {DogLegOptimizerEditDto}
     */
    setup(props) {
        super.setup(props);

        this.initialTrustRadius = props.initialTrustRadius;
        this.maxTrustRadius = props.maxTrustRadius;
        this.tol = props.tol;
        this.eta = props.eta;
        this.gtol = props.gtol;
        return this;
    }
}

export default DogLegOptimizerEditDto;